"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractSortFields = exports.extractFilterFields = void 0;
/**
 * Извлечь readonly tuple допустимых filter-полей из zod-схемы.
 *
 * При compose paradigm передаём **Domain** — platform-полей (`id`, `tenantId`,
 * `createdAt`, `updatedAt`) там нет, исключать нечего. Дополнительные exclude'ы
 * (например JSON-поля не подходящие для WHERE) — через `opts.exclude`.
 *
 * Возвращаемый тип **сохраняет имена ключей** из Domain — downstream
 * (`crudFilterSchema`) выведет `CrudFilterAst<'name'|'status'|...>` вместо
 * `CrudFilterAst<string>`, и IDE подскажет допустимые поля в filter.
 *
 * @example
 *   const FooFilterFields = extractFilterFields(FooDomain);
 *   // → ['name', 'status', 'count']  тип: readonly ['name'|'status'|'count', ...]
 *
 *   const FooFilterFields = extractFilterFields(FooDomain, {
 *     exclude: ['data'],  // jsonb — не фильтруемое
 *   });
 *
 * @throws если после exclude осталось 0 полей (z.enum требует non-empty).
 */
const extractFilterFields = (schema, opts = {}) => {
    const excludeSet = new Set(opts.exclude ?? []);
    const fields = Object.keys(schema.shape).filter((k) => !excludeSet.has(k));
    if (fields.length === 0) {
        throw new Error(`extractFilterFields: no fields left after excluding ${[...excludeSet].join(', ')}`);
    }
    return fields;
};
exports.extractFilterFields = extractFilterFields;
/**
 * Алиас для семантической ясности — sort-fields обычно strict subset filter-fields
 * (только scalar-сортируемые: id/datetime/number/string, не array/JSON).
 */
exports.extractSortFields = exports.extractFilterFields;
//# sourceMappingURL=extract-fields.js.map